module.exports = __webpack_public_path__ + "static/media/lp-4.e3830e0f.png";